// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__iwqQL","col":"Table_col__3Uku9","fulfillmentStatus":"Table_fulfillmentStatus__5SUNM","emailCol":"Table_emailCol__3Ftky"};